/* tslint:disable */
/* eslint-disable */
/**
 * FreightSimple Hubble API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import type { OffsetDateTime } from "@freightsimple/time/branded-types";

import { mapValues } from "../runtime";
import type { JobApplicationStatus } from "./JobApplicationStatus";
import {
  JobApplicationStatusFromJSON,
  JobApplicationStatusFromJSONTyped,
  JobApplicationStatusToJSON,
  JobApplicationStatusToJSONTyped,
} from "./JobApplicationStatus";

/**
 *
 * @export
 * @interface ApplicationSummary
 */
export interface ApplicationSummary {
  /**
   *
   * @type {string}
   * @memberof ApplicationSummary
   */
  applicationId: string;
  /**
   *
   * @type {string}
   * @memberof ApplicationSummary
   */
  role: string;
  /**
   *
   * @type {string}
   * @memberof ApplicationSummary
   */
  name: string;
  /**
   *
   * @type {string}
   * @memberof ApplicationSummary
   */
  email: string;
  /**
   *
   * @type {JobApplicationStatus}
   * @memberof ApplicationSummary
   */
  status: JobApplicationStatus;
  /**
   *
   * @type {string}
   * @memberof ApplicationSummary
   */
  source?: string | null;
  /**
   *
   * @type {string}
   * @memberof ApplicationSummary
   */
  location?: string | null;
  /**
   *
   * @type {boolean}
   * @memberof ApplicationSummary
   */
  hasResume: boolean;
  /**
   *
   * @type {OffsetDateTime}
   * @memberof ApplicationSummary
   */
  submittedAt: OffsetDateTime;
  /**
   *
   * @type {string}
   * @memberof ApplicationSummary
   */
  salaryExpectation?: string | null;
  /**
   *
   * @type {string}
   * @memberof ApplicationSummary
   */
  currency?: string | null;
  /**
   *
   * @type {string}
   * @memberof ApplicationSummary
   */
  englishLevel?: string | null;
}

/**
 * Check if a given object implements the ApplicationSummary interface.
 */
export function instanceOfApplicationSummary(
  value: object,
): value is ApplicationSummary {
  if (!("applicationId" in value) || value["applicationId"] === undefined)
    return false;
  if (!("role" in value) || value["role"] === undefined) return false;
  if (!("name" in value) || value["name"] === undefined) return false;
  if (!("email" in value) || value["email"] === undefined) return false;
  if (!("status" in value) || value["status"] === undefined) return false;
  if (!("hasResume" in value) || value["hasResume"] === undefined) return false;
  if (!("submittedAt" in value) || value["submittedAt"] === undefined)
    return false;
  return true;
}

export function ApplicationSummaryFromJSON(json: any): ApplicationSummary {
  return ApplicationSummaryFromJSONTyped(json, false);
}

export function ApplicationSummaryFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): ApplicationSummary {
  if (json == null) {
    return json;
  }
  return {
    applicationId: json["applicationId"],
    role: json["role"],
    name: json["name"],
    email: json["email"],
    status: JobApplicationStatusFromJSON(json["status"]),
    source: json["source"] == null ? undefined : json["source"],
    location: json["location"] == null ? undefined : json["location"],
    hasResume: json["hasResume"],
    submittedAt: json["submittedAt"],
    salaryExpectation:
      json["salaryExpectation"] == null ? undefined : json["salaryExpectation"],
    currency: json["currency"] == null ? undefined : json["currency"],
    englishLevel:
      json["englishLevel"] == null ? undefined : json["englishLevel"],
  };
}

export function ApplicationSummaryToJSON(json: any): ApplicationSummary {
  return ApplicationSummaryToJSONTyped(json, false);
}

export function ApplicationSummaryToJSONTyped(
  value?: ApplicationSummary | null,
  ignoreDiscriminator: boolean = false,
): any {
  if (value == null) {
    return value;
  }

  return {
    applicationId: value["applicationId"],
    role: value["role"],
    name: value["name"],
    email: value["email"],
    status: JobApplicationStatusToJSON(value["status"]),
    source: value["source"],
    location: value["location"],
    hasResume: value["hasResume"],
    submittedAt: value["submittedAt"],
    salaryExpectation: value["salaryExpectation"],
    currency: value["currency"],
    englishLevel: value["englishLevel"],
  };
}
